import AbstractRepository from '@services/repositories/AbstractRepository';

export default class PrinterRepository extends AbstractRepository {
    constructor() {
        super();
        this.setApiUrl('/vue/printers/list');
    }

    getById(id) {
        return this.where('id', id);
    }

    getByIds(ids) {
        return this.whereIn('id', ids);
    }
}
